import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoModule, TranslocoService } from "@jsverse/transloco";
import { CommonModule } from '@angular/common';
import { BookingConfigService } from '../../services/booking-config.service';
import { formatTerminalLocationForDate } from '../../../models/BookingModel';

@Component({
  selector: 'app-booking-summary-card',
  imports: [DatePipe, TranslocoModule, CommonModule],
  templateUrl: './booking-summary-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './booking-summary-card.component.scss',
})
export class BookingSummaryCardComponent {
  @Input() bookingDetails: any;
  @Input() booking: any;
  site: string;
  freeShuttles: boolean;
  locale = 'sv';
  constructor(private translocoService: TranslocoService, private bookingConfigService: BookingConfigService) {
    this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });

    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    this.freeShuttles = config.freeShuttles;
  }

  getDepartureTerminalName(): string {
    const term = this.booking?.departure?.terminalName;
    const date = this.booking?.departure?.scheduledDeparture || this.booking?.parkingFromActual;
    return formatTerminalLocationForDate(term, date);
  }

  getArrivalTerminalName(): string {
    const term = this.booking?.arrival?.terminalName;
    const date = this.booking?.arrival?.scheduledArrival || this.booking?.parkingTo;
    return formatTerminalLocationForDate(term, date);
  }

}

